import { DateDomainService } from '@/domain/services';

export type PresignedUrl = {
  image_url: string;
  file?: File;
  presigned_url: string;
};

export const reRequestMessage = (name: string): string => {
  return `${name}の画像アップロードに失敗しました。お手数ですが再度画像を変更して更新してください。`;
};

export const validateMessage = (name: string): string => {
  return `${name}の画像アップロードに失敗しました。`;
};

export const JPEG = { type: 'image/jpeg', name: 'JPG' } as const;
export const PNG = { type: 'image/png', name: 'PNG' } as const;
export const WEBP = { type: 'image/webp', name: 'WEBP' } as const;
export const GIF = { type: 'image/gif', name: 'GIF' } as const;

export const getFilePath = (now: Date): string => {
  const { yyyymmdd } = DateDomainService;
  const filePath = `${yyyymmdd(now)}/${now.getTime()}`;
  return filePath;
};

export const getRequestImageUrl = (
  presignedUrl: string,
  imageUrl: string
): string | null => {
  if (imageUrl === '') return null; // 画像を登録がない時
  // 画像を登録、もしくは新しく更新をするとき
  if (presignedUrl !== '') {
    return presignedUrl.split('?')[0];
  }
  return imageUrl; // 画像がすでに登録をされていて、変更がない時、
  // presignedUrl !== '' ? presignedUrl.split('?')[0] : imageUrl;
};

type Unit = 'TB' | 'GB' | 'MB' | 'KB' | 'byte';
/**
 * @note 入力されたファイルサイズを元に計算につかうバイト数と単位を返却
 */
const getTargetUnit = (
  size: number
): {
  target: number | null;
  unit: Unit;
} => {
  const kb = 1024;
  const mb = Math.pow(kb, 2);
  const gb = Math.pow(kb, 3);
  const tb = Math.pow(kb, 4);

  const returnData = (target: number | null, unit: Unit) => ({
    target,
    unit,
  });

  if (size >= tb) return returnData(tb, 'TB');
  if (size >= gb) return returnData(gb, 'GB');
  if (size >= mb) return returnData(mb, 'MB');
  if (size >= kb) return returnData(kb, 'KB');

  return returnData(null, 'byte');
};

/**
 * @note ファイルサイズを適切な単位に変換
 */
export const unitChangeForByte = (size: number): string => {
  const { target, unit } = getTargetUnit(size);
  const newSize =
    target !== null
      ? Math.floor((size / target) * Math.pow(10, 2)) / Math.pow(10, 2)
      : size;
  return newSize + unit;
};
